import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Shield } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  return <AnimatePresence data-id="element-127">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60] flex items-center justify-center p-4" data-id="element-128">
            {/* Modal Container */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-4xl max-h-[90vh] flex flex-col bg-gaming-card border border-gaming-cyan/30 rounded-xl shadow-[0_0_50px_rgba(0,217,255,0.15)] overflow-hidden" data-id="element-129">
              {/* Header */}
              <div className="p-6 border-b border-white/10 flex justify-between items-center bg-gaming-dark/95 backdrop-blur sticky top-0 z-10" data-id="element-130">
                <div className="flex items-center gap-3" data-id="element-131">
                  <Shield className="w-6 h-6 text-gaming-cyan" data-id="element-132" />
                  <h2 className="text-xl md:text-2xl font-bold font-display text-white uppercase tracking-wide" data-id="element-133">
                    Política de{' '}
                    <span className="text-gaming-cyan" data-id="element-134">Privacidad AEDE</span>
                  </h2>
                </div>
                <button onClick={onClose} className="text-gray-400 hover:text-white hover:bg-white/10 p-2 rounded-full transition-colors" data-id="element-135">
                  <X className="w-6 h-6" data-id="element-136" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto p-6 md:p-8 space-y-8 text-gray-300 leading-relaxed" data-id="element-137">
                {/* Section 1 */}
                <section data-id="element-138">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-139">
                    <span className="text-gaming-cyan" data-id="element-140">1.</span> AVISO LEGAL
                  </h3>
                  <div className="space-y-4 pl-4 border-l-2 border-white/5" data-id="element-141">
                    <div data-id="element-142">
                      <h4 className="font-bold text-white mb-1" data-id="element-143">
                        1.1 Propósito del sitio web y su APP
                      </h4>
                      <p data-id="element-144">
                        Este portal y su APP constituye parte de la plataforma
                        digital oficial de la Asociación Ecuatoriana de Deportes
                        Electrónicos (AEDE), entidad encargada de regular y
                        promover los esports en Ecuador. La navegación y uso de
                        este sitio o de su APP implica la aceptación plena de
                        los términos aquí establecidos.
                      </p>
                    </div>
                    <div data-id="element-145">
                      <h4 className="font-bold text-white mb-1" data-id="element-146">
                        1.2 Propiedad intelectual
                      </h4>
                      <p data-id="element-147">
                        Todos los contenidos publicados en este sitio web y su
                        APP, incluyendo textos, imágenes, logotipos, diseños y
                        material audiovisual, son propiedad exclusiva de AEDE o
                        se utilizan bajo licencias debidamente autorizadas.
                        Queda estrictamente prohibida su reproducción,
                        modificación o distribución sin autorización previa por
                        escrito.
                      </p>
                    </div>
                    <div data-id="element-148">
                      <h4 className="font-bold text-white mb-1" data-id="element-149">
                        1.3 Exactitud de la información
                      </h4>
                      <p data-id="element-150">
                        AEDE se esfuerza por mantener información actualizada y
                        veraz, pero no garantiza la ausencia total de errores u
                        omisiones. Los usuarios deben verificar la vigencia de
                        los contenidos, especialmente en lo relacionado con
                        calendarios de eventos, reglamentos y procesos
                        competitivos.
                      </p>
                    </div>
                    <div data-id="element-151">
                      <h4 className="font-bold text-white mb-1" data-id="element-152">
                        1.4 Enlaces externos
                      </h4>
                      <p data-id="element-153">
                        El sitio y su APP pueden contener vínculos a páginas de
                        terceros relacionados con el ecosistema esports. AEDE no
                        asume responsabilidad por el contenido, políticas de
                        privacidad o prácticas de estos sitios externos, cuyo
                        acceso es bajo responsabilidad exclusiva del usuario.
                      </p>
                    </div>
                    <div data-id="element-154">
                      <h4 className="font-bold text-white mb-1" data-id="element-155">
                        1.5 Condiciones de acceso
                      </h4>
                      <p data-id="element-156">
                        El uso básico del sitio web y su APP es gratuito, pero
                        ciertas funcionalidades como inscripciones a torneos,
                        solicitud de licencias o acceso a áreas exclusivas
                        requieren registro previo y aceptación de condiciones
                        específicas. Los usuarios son responsables de
                        proporcionar información veraz y mantener sus
                        credenciales de acceso seguras.
                      </p>
                    </div>
                    <div data-id="element-157">
                      <h4 className="font-bold text-white mb-1" data-id="element-158">
                        1.6 Marco legal aplicable
                      </h4>
                      <p data-id="element-159">
                        Este sitio web, su APP y todas sus actividades se rigen
                        por las leyes de la República del Ecuador. Cualquier
                        controversia relacionada con su uso será resuelta en los
                        tribunales competentes de acuerdo con la legislación
                        ecuatoriana vigente.
                      </p>
                    </div>
                  </div>
                </section>

                {/* Section 2 */}
                <section data-id="element-160">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-161">
                    <span className="text-gaming-cyan" data-id="element-162">2.</span> RECOPILACIÓN DE
                    DATOS PERSONALES
                  </h3>
                  <p className="mb-4" data-id="element-163">
                    En la Asociación Ecuatoriana de Deportes Electrónicos
                    (AEDE), valoramos la privacidad de nuestros miembros y
                    participantes. Recopilamos información personal únicamente
                    cuando es necesaria para nuestras actividades como entidad
                    reguladora de esports en Ecuador, siempre con el
                    consentimiento previo y expreso del titular.
                  </p>
                  <div className="space-y-4 pl-4 border-l-2 border-white/5" data-id="element-164">
                    <div data-id="element-165">
                      <h4 className="font-bold text-white mb-1" data-id="element-166">
                        2.1 Tipos de datos recopilados
                      </h4>
                      <p data-id="element-167">
                        Para garantizar el correcto desarrollo de nuestras
                        competencias y servicios, requerimos información básica
                        como nombre completo, documento de identidad, datos de
                        contacto y en el caso de torneos presenciales,
                        certificados médicos vigentes. Los deportistas deben
                        proporcionar adicionalmente su historial competitivo y,
                        cuando corresponda, autorizaciones para menores de edad.
                      </p>
                    </div>
                    <div data-id="element-168">
                      <h4 className="font-bold text-white mb-1" data-id="element-169">
                        2.2 Métodos de recolección
                      </h4>
                      <p data-id="element-170">
                        La información es proporcionada directamente por los
                        usuarios a través de nuestros formularios digitales
                        seguros durante procesos de registro, licenciamiento o
                        inscripción a eventos. Utilizamos sistemas con cifrado
                        para garantizar la protección de los datos durante su
                        transmisión y almacenamiento.
                      </p>
                    </div>
                    <div data-id="element-171">
                      <h4 className="font-bold text-white mb-1" data-id="element-172">
                        2.3 Finalidad del tratamiento
                      </h4>
                      <p data-id="element-173">
                        Los datos personales son utilizados exclusivamente para
                        gestionar participaciones en torneos, emitir licencias
                        oficiales, mantener actualizado el Data Center, mantener
                        comunicaciones institucionales y cumplir con
                        obligaciones legales como entidad deportiva. En ningún
                        caso utilizamos esta información para fines distintos a
                        los aquí establecidos.
                      </p>
                    </div>
                    <div data-id="element-174">
                      <h4 className="font-bold text-white mb-1" data-id="element-175">
                        2.4 Consentimiento y transparencia
                      </h4>
                      <p data-id="element-176">
                        Toda recolección de datos se realiza previa aceptación
                        expresa de nuestra política de privacidad. Los usuarios
                        pueden consultar en cualquier momento qué información
                        tenemos almacenada, solicitar su corrección o
                        eliminación.
                      </p>
                    </div>
                    <div data-id="element-177">
                      <h4 className="font-bold text-white mb-1" data-id="element-178">
                        2.5 Protección de datos sensibles
                      </h4>
                      <p data-id="element-179">
                        AEDE no solicita ni almacena información considerada
                        sensible según la legislación ecuatoriana, excepto
                        cuando sea estrictamente necesario para el cumplimiento
                        de normativas deportivas internacionales y siempre con
                        autorización explícita del titular.
                      </p>
                    </div>
                  </div>
                  <p className="mt-4 text-sm text-gray-400 italic" data-id="element-180">
                    Para ejercer cualquier derecho sobre sus datos personales o
                    resolver inquietudes sobre su tratamiento, los usuarios
                    pueden contactarnos a través del correo electrónico
                    oficial@aede.ec, donde atenderemos sus solicitudes.
                  </p>
                </section>

                {/* Sections 3-6 abbreviated for brevity - include full content in production */}
                <section data-id="element-181">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-182">
                    <span className="text-gaming-cyan" data-id="element-183">3.</span> USO DE LA
                    INFORMACIÓN RECOPILADA
                  </h3>
                  <p className="mb-4" data-id="element-184">
                    En la Asociación Ecuatoriana de Deportes Electrónicos
                    (AEDE), utilizamos la información personal de nuestros
                    usuarios únicamente para los fines establecidos, asegurando
                    siempre el manejo ético y responsable de los datos bajo los
                    más altos estándares de protección.
                  </p>
                </section>

                <section data-id="element-185">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-186">
                    <span className="text-gaming-cyan" data-id="element-187">4.</span> DERECHOS DE LOS
                    USUARIOS
                  </h3>
                  <p className="mb-4" data-id="element-188">
                    En la Asociación Ecuatoriana de Deportes Electrónicos
                    (AEDE), garantizamos el pleno ejercicio de los derechos de
                    protección de datos personales de nuestros miembros y
                    participantes, en cumplimiento de la Ley Orgánica de
                    Protección de Datos Personales del Ecuador.
                  </p>
                </section>

                <section data-id="element-189">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-190">
                    <span className="text-gaming-cyan" data-id="element-191">5.</span> COMPARTICIÓN DE
                    INFORMACIÓN CON TERCEROS
                  </h3>
                  <p className="mb-4" data-id="element-192">
                    En la Asociación Ecuatoriana de Deportes Electrónicos
                    (AEDE), protegemos rigurosamente los datos personales de
                    nuestros miembros y participantes. La información solo se
                    comparte en las siguientes situaciones específicas y
                    debidamente justificadas.
                  </p>
                </section>

                <section data-id="element-193">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-194">
                    <span className="text-gaming-cyan" data-id="element-195">6.</span> ACTUALIZACIONES
                    DE LA POLÍTICA
                  </h3>
                  <p className="mb-4" data-id="element-196">
                    La Asociación Ecuatoriana de Deportes Electrónicos (AEDE)
                    podrá modificar esta Política de Privacidad para mantenerla
                    actualizada conforme a nuevos requerimientos legales,
                    cambios operativos o mejoras en estándares.
                  </p>
                </section>
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-white/10 bg-gaming-dark/95 backdrop-blur flex justify-end" data-id="element-197">
                <button onClick={onClose} className="px-6 py-3 bg-gaming-cyan/10 text-gaming-cyan border border-gaming-cyan/50 font-bold rounded hover:bg-gaming-cyan/20 transition-all uppercase tracking-wide" data-id="element-198">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}